/*
 * @Author: Daokai Huo
 * @Date: 2021-10-09 09:44:39
 * @LastEditTime: 2021-10-09 09:45:19
 * @Description:
 */
import IonUpload from './src/ion-upload.vue';

IonUpload.install = function install(_vue) {
  _vue.component(IonUpload.name, IonUpload);
};
export default IonUpload;
